import svgFlag from './media/logo-flag';
import svgFont from './media/logo-font';

const template = `
<style>
  .background {
    max-width: 100%;
    overflow: hidden;
  }
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  img {
  height: 5rem;
  }
</style>
<div part="logo" class="background">
  <a part="link" href="https://www.vs.ch">
      <img part="flag" class="flag" alt src="data:image/svg+xml;utf8,${svgFlag}"/>
      <img part="font" class="font" alt src="data:image/svg+xml;utf8,${svgFont}"/>
  </a>
</div>
`;
export default template;
